// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleOwner_root__3nHoF"};